module.exports = __webpack_public_path__ + "static/media/PWID-X-03.de5e2b2c.png";